import React from "react";

const DocumentIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0832 6.66663V15.8333H5.4165V1.66663H12.4998M17.0832 6.66663H12.4998V1.66663M17.0832 6.66663L12.4998 1.66663"
        stroke="#E4E4E2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.9165 8.33325V18.3333H11.6665"
        stroke="#E4E4E2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.9165 8.33325H9.58317M7.9165 11.6666H12.9165"
        stroke="#E4E4E2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default DocumentIcon;
